<script setup lang="ts">
import ReportCardStepOne from "./ReportCardStepOne.vue";
import ReportCardStepTwo from "./ReportCardStepTwo.vue";
import ReportCardStepThree from "./ReportCardStepThree.vue";
import { useRouter, useRoute } from "vue-router";

enum Steps {
  StepOne = "Step-1",
  StepTwo = "Step-2",
  StepThree = "Step-3",
}

const router = useRouter();
const route = useRoute();

const goToNextStep = () => {
  if (route.params.step === Steps.StepOne) {
    router.push({ name: "ReportCardSteps", params: { step: Steps.StepTwo } });
  } else if (route.params.step === Steps.StepTwo) {
    router.push({ name: "ReportCardSteps", params: { step: Steps.StepThree } });
  }
};

const goToPreviousStep = () => {
  router.back();
};
</script>

<template>
  <div>
    <ReportCardStepOne
      v-if="route.params.step === Steps.StepOne"
      @next="goToNextStep"
    />
    <ReportCardStepTwo
      v-else-if="route.params.step === Steps.StepTwo"
      @next="goToNextStep"
      @back="goToPreviousStep"
    />
    <ReportCardStepThree
      v-else-if="route.params.step === Steps.StepThree"
      @back="goToPreviousStep"
    />
  </div>
</template>
